"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _extends3 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _pickReactKnownProp = require("pick-react-known-prop");

var _styles = require("@material-ui/core/styles");

var _useMediaQuery = _interopRequireDefault(require("@material-ui/core/useMediaQuery"));

var _useTranslate = _interopRequireDefault(require("@sprinx/react-globalize/useTranslate"));

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _Sort = _interopRequireDefault(require("@material-ui/icons/Sort"));

var _startsWith = _interopRequireDefault(require("lodash/startsWith"));

var _CatalogueProductListPageSize = _interopRequireDefault(require("./CatalogueProductListPageSize"));

var _CatalogueProductListOnlyStockCheckbox = _interopRequireDefault(require("./CatalogueProductListOnlyStockCheckbox"));

var _AzIcon = _interopRequireDefault(require("./AzIcon"));

var _ZaIcon = _interopRequireDefault(require("./ZaIcon"));

var btnColor = function btnColor(btnNam, a) {
  return (0, _startsWith.default)(a, btnNam) ? 'primary' : 'default';
};

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      borderBottom: '1px solid',
      borderBottomColor: theme.palette.divider
    },
    container: (0, _defineProperty2.default)({
      marginBottom: theme.spacing(1),
      display: 'flex',
      alignItems: 'center',
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1)
    }, theme.breakpoints.down('sm'), {
      flexDirection: 'column',
      alignItems: 'flex-start'
    }),
    btn: {
      display: 'flex',
      alignItems: 'center',
      marginRight: theme.spacing(2),
      textTransform: 'none',
      fontSize: 14
    },
    selectLabel: (0, _extends3.default)({}, theme.typography.body1, (0, _defineProperty2.default)({
      marginRight: theme.spacing(2)
    }, theme.breakpoints.down('sm'), {
      fontSize: 14,
      paddingLeft: theme.spacing(0.6)
    })),
    revertedIcon: {
      transform: 'rotate(180deg) scaleX(-1)',
      paddingLeft: theme.spacing(0.5)
    },
    normalIcon: {
      transform: 'rotate(0deg) scaleX(-1)'
    },
    wrapper: {
      display: 'flex'
    },
    alphaIcon: {
      paddingLeft: theme.spacing(0.5),
      width: theme.spacing(3),
      display: 'flex'
    },
    active: {
      fill: theme.palette.primary.main
    }
  };
}, {
  name: 'SxComProductListOrderSelectorButton'
});

function ProductListOrderSelectorButton(_ref) {
  var pClasses = _ref.classes,
      className = _ref.className,
      onChange = _ref.onChange,
      handleChangeRowsPerPage = _ref.onChangeRowsPerPage,
      handleChangeStockOnly = _ref.onChangeStockOnly,
      rowsPerPage = _ref.rowsPerPage,
      stockOnly = _ref.stockOnly,
      value = _ref.value,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["classes", "className", "onChange", "onChangeRowsPerPage", "onChangeStockOnly", "rowsPerPage", "stockOnly", "value"]);
  var t = (0, _useTranslate.default)();
  var classes = useStyles({
    classes: pClasses
  });
  var theme = (0, _styles.useTheme)();
  var mobile = (0, _useMediaQuery.default)(theme.breakpoints.down('sm'));

  var createClickHandler = _react.default.useCallback(function (ord) {
    return function () {
      if (onChange) onChange(ord);
    };
  }, [onChange]);

  var IconNameComponent = value === 'nameDesc' ? _ZaIcon.default : _AzIcon.default;
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends3.default)({}, (0, _pickReactKnownProp.pickHTMLProps)(rest), {
    className: (0, _clsx.default)(classes.root, className)
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.container
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: classes.selectLabel
  }, t('productListOrderSelectorButton/selectLabel')), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.wrapper
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    size: "small",
    color: btnColor('name', value),
    onClick: createClickHandler(value === 'nameAsc' ? 'nameDesc' : 'nameAsc'),
    className: classes.btn
  }, t('productListOrderSelectorButton/byName'), /*#__PURE__*/_react.default.createElement(IconNameComponent, {
    className: (0, _clsx.default)(classes.alphaIcon, value.startsWith('name') && classes.active)
  })), /*#__PURE__*/_react.default.createElement(_Button.default, {
    size: "small",
    color: btnColor('listPrice', value),
    onClick: createClickHandler(value === 'listPriceAsc' ? 'listPriceDesc' : 'listPriceAsc'),
    className: classes.btn
  }, t('productListOrderSelectorButton/byPrice'), /*#__PURE__*/_react.default.createElement(_Sort.default, {
    className: (0, _clsx.default)(classes.revertedIcon, value.startsWith('list') && classes.active, value === 'listPriceDesc' && classes.normalIcon)
  })), /*#__PURE__*/_react.default.createElement(_CatalogueProductListOnlyStockCheckbox.default, {
    onChange: handleChangeStockOnly,
    value: stockOnly
  }))), !mobile && /*#__PURE__*/_react.default.createElement(_CatalogueProductListPageSize.default, {
    onChange: handleChangeRowsPerPage,
    rowsPerPage: rowsPerPage
  }));
}

process.env.NODE_ENV !== "production" ? ProductListOrderSelectorButton.propTypes = {
  classes: _propTypes.default.shape({
    active: _propTypes.default.string,
    alphaIcon: _propTypes.default.string,
    btn: _propTypes.default.string,
    container: _propTypes.default.string,
    normalIcon: _propTypes.default.string,
    revertedIcon: _propTypes.default.string,
    root: _propTypes.default.string,
    selectLabel: _propTypes.default.string,
    stockOnly: _propTypes.default.bool,
    wrapper: _propTypes.default.string
  }),
  className: _propTypes.default.string,
  onChange: _propTypes.default.func,
  onChangeRowsPerPage: _propTypes.default.func,
  onChangeStockOnly: _propTypes.default.func,
  rowsPerPage: _propTypes.default.number,
  stockOnly: _propTypes.default.bool,
  value: _propTypes.default.string
} : void 0;
ProductListOrderSelectorButton.defaultProps = {
  classes: undefined,
  className: undefined,
  onChange: undefined,
  onChangeRowsPerPage: undefined,
  onChangeStockOnly: undefined,
  rowsPerPage: undefined,
  stockOnly: undefined,
  value: {}
};
var _default = ProductListOrderSelectorButton;
exports.default = _default;